import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
export const Menu = ({ scrollToTarget }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 769);

    const handleOpacity = (e, classed, opacity, decor) => {
        const target = e.target;
        if (target.classList.contains(classed)) {
            const listItems = document.querySelectorAll(`.${classed}`);
            listItems.forEach((item) => {
                if (item !== target) {
                    item.style.opacity = opacity;
                    item.style.textDecoration = decor;
                }
            });
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 860);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div className={`Menu ${isMobile ? "MobileMenu" : ""}`}>
            <Fade className="Logo-Link">
                <Link>
                    <div className="Logo"></div>
                    {/* //\//|||/. */}
                </Link>
            </Fade>
            {isMobile ? (
                // Hamburger Menu
                <div className="top-nav">
                    <input id="menu-toggle" type="checkbox" />
                    <label className="menu-button-container" for="menu-toggle">
                        <div className="menu-button"></div>
                    </label>
                    <ul className="menu">
                        <li onClick={() => scrollToTarget("MyWork")}>
                            Projects
                        </li>
                        <li onClick={() => scrollToTarget("Skills")}>Skills</li>
                        <li onClick={() => scrollToTarget("Education")}>
                            Education
                        </li>
                        <li onClick={() => scrollToTarget("HireMe")}>
                            Hire Me
                        </li>
                    </ul>
                </div>
            ) : (
                // Regular Menu
                <div
                    className="Menu-Options"
                    onMouseOver={(e) =>
                        handleOpacity(e, "list-item", 0.25, "line-through")
                    }
                    onMouseOut={(e) => handleOpacity(e, "list-item", 1, "none")}
                >
                    <Fade delay={300}>
                        <div
                            onClick={() => scrollToTarget("MyWork")}
                            className="list-item"
                        >
                            <i className="fa-solid fa-laptop-code "></i>{" "}
                            Projects
                        </div>
                    </Fade>
                    <Fade delay={500}>
                        <div
                            onClick={() => scrollToTarget("Skills")}
                            className="list-item"
                        >
                            <i className="fa-solid fa-arrow-up-right-dots "></i>{" "}
                            Skills
                        </div>
                    </Fade>
                    <Fade delay={600}>
                        <div
                            onClick={() => scrollToTarget("Education")}
                            className="list-item"
                        >
                            <i className="fa-solid fa-graduation-cap"></i>{" "}
                            Education
                        </div>
                    </Fade>
                    <Fade delay={700}>
                        <div
                            onClick={() => scrollToTarget("HireMe")}
                            className="list-item"
                        >
                            <i className="fa-solid fa-mobile-screen-button"></i>{" "}
                            Hire me
                        </div>
                    </Fade>
                </div>
            )}
        </div>
    );
};
